export const load = () => ({
	title: 'Lock In Current Savings: Indow Pricing Update',
	h1: 'Lock In Your Savings Before Prices Increase',
	description:
		'Indow prices increase 10% on July 1. Lock in current rates for noise blocking & energy saving inserts today. Order by June 30 to save.',
	showTitle: true,
});
